export { handler as default } from '../lib/middleware/handler.js';
